<template>
  <div>
    <van-nav-bar
      :title="title"
      :left-text="navLeftText"
      left-arrow
      @click-left="back"
      :fixed="true"
    >
      <template #right>
        <van-icon name="vip-card-o" size="18" @click="showInfo()" v-if="now < user.vod_end_date"/>
        <van-icon name="user-o" size="18" @click="showInfo()" v-else/>
      </template>
    </van-nav-bar>
    <router-view style="margin-top: 48px;"></router-view>
    <van-overlay :show="showLoading" @click="showLoading = false" style="display: flex; justify-items: center; justify-content: center; align-items: center;">
      <van-loading type="spinner" />
    </van-overlay>
  </div>
</template>

<script>
import { getUserInfo } from '@/api/user'
import { baseMixin } from '@/libs/app-mixin'
import { User } from '@/api/model'

export default {
  name: 'VodLayout',
  mixins: [baseMixin],
  data () {
    return {
      now: 0,
      title: '',
      navLeftText: '',
      showLoading: false,
      user: User()
    }
  },
  created () {
    this.now = Date.parse(new Date()) / 1000
    this.$parent.isLoadUser = false
    this.$parent.showHeader = false
    this.$parent.showFooter = false
    this.$parent.showSkeleton = false
    document.title = '华人影视'
  },
  methods: {
    getUserInfo () {
      getUserInfo({}).then(res => {
        this.user = res.result
        this.user.vod_end_date = parseFloat(this.user.vod_end_date)
      })
    },
    isVip () {
      if (this.user.vod_end_date === '') {
        return false
      }
      if (this.user.vod_end_date > this.now) {
        return true
      } else {
        this.$message.info('会员服务' + this.timeStamp2Date(this.user.vod_end_date) + '已到期')
        return false
      }
    },
    showInfo () {
      this.$message.success('会员有效期：' + this.timeStamp2Date(this.user.vod_end_date))
    },
    back () {
      this.navLeftText = '退出'
      this.title = '华人影视'
      this.progressOff()
      if (location.href.indexOf('/#/in-app/vod/home') !== -1) {
        if (typeof window.webkit !== 'undefined') {
          window.webkit.messageHandlers.back.postMessage('')
        } else {
          window.close()
        }
      } else {
        history.go(-1)
        // setTimeout(() => {
        //   window.scrollTo({ top: 0, behavior: 'smooth' })
        // }, 100)
      }
    },
    progressOn () {
      setTimeout(() => {
        this.progressOff()
      }, 30 * 1000)
      if (typeof window.webkit === 'undefined') {
        this.showLoading = true
        return
      }
      window.webkit.messageHandlers.progress_on.postMessage('')
    },
    progressOff () {
      if (typeof window.webkit === 'undefined') {
        this.showLoading = false
        return
      }
      window.webkit.messageHandlers.progress_off.postMessage('')
    },
    change () {
      this.title = '华人影视'
      this.navLeftText = '退出'
      this.getUserInfo()
    }
  },
  mounted () {
    this.change()
  }
}
</script>

<style scoped>
.header-bg {
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 64px;
  position: absolute;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/inApp/Vod/Layout.vue